import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/credit_card_plan.svg'


const _hoisted_1 = { class: "card-content" }
const _hoisted_2 = { class: "d-flex flex-column gap-3 align-items-center" }
const _hoisted_3 = { class: "d-flex flex-column gap-1 align-items-center" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = {
  key: 1,
  class: "name"
}
const _hoisted_6 = { class: "d-flex gap-2" }
const _hoisted_7 = { class: "categories-tags" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-father", {
    'card-father-hover': $setup.thisInstance?.vnode?.props?.changePage,
  }]),
    onClick: _cache[0] || (_cache[0] = () => _ctx.$emit('change-page'))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          src: _imports_0,
          alt: "Blob pattern"
        }, null, -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode($setup["CurrencyValue"], {
            value: $props.benefitsCardPlan.getPlanValue(),
            fontReal: 28,
            fontSize: 16
          }, null, 8 /* PROPS */, ["value"]),
          ($props.benefitsCardPlan.getPlanName().length >= $setup.textEllipsisSize)
            ? (_openBlock(), _createBlock($setup["Tooltip"], {
                key: 0,
                text: $props.benefitsCardPlan.getPlanName()
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h3", _hoisted_4, _toDisplayString($setup.FormatUtils.ellipsis($props.benefitsCardPlan.getPlanName(), $setup.textEllipsisSize)), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["text"]))
            : (_openBlock(), _createElementBlock("h3", _hoisted_5, _toDisplayString($props.benefitsCardPlan.getPlanName()), 1 /* TEXT */))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode($setup["CardTag"], {
            icon: $setup.Icons.imported.faUser,
            message: ($props.benefitsCardPlan.getUserCount()).toString(),
            size: "small"
          }, null, 8 /* PROPS */, ["icon", "message"]),
          _createCommentVNode(" <ToggleActive :active=\"true\" :message=\"true ? 'Ativo' : 'Inativo'\"/> ")
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.benefitsCardPlan.getCategories(), (category, index) => {
          return (_openBlock(), _createBlock($setup["CardTag"], {
            key: index,
            icon: $setup.CardCategoryUtils.getIconFromCategory(category.getCategory()),
            iconTitle: category.getCustomCategory().toString(),
            message: $setup.FormatUtils.money(category.getValue(), true)
          }, null, 8 /* PROPS */, ["icon", "iconTitle", "message"]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    (!$props.hideControls)
      ? (_openBlock(), _createBlock($setup["ContextMenu"], {
          key: 0,
          class: "context-menu",
          buttons: [
        {
          text: 'Renovar',
          action: () => _ctx.$emit('renew'),
          visible: ($setup.LoggedAdminStorage.getUser()?.getIsSuperAdmin() || $setup.LoggedAdminStorage.getUser()?.hasPermissions([$setup.Permission.fromResource($setup.Resource.CREDIT_CARD_PLANS, 'write')])) && Boolean($props.benefitsCardPlan.getUserCount()),
        },
        {
          text: 'Excluir',
          action: () => _ctx.$emit('remove'),
          visible: ($setup.LoggedAdminStorage.getUser()?.getIsSuperAdmin() || $setup.LoggedAdminStorage.getUser()?.hasPermissions([$setup.Permission.fromResource($setup.Resource.CREDIT_CARD_PLANS, 'delete')]))
        }
      ]
        }, null, 8 /* PROPS */, ["buttons"]))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["CardBlob"], { class: "blob" })
  ], 2 /* CLASS */))
}